import React from 'react'
import '../styles/anime.css'

function Anime() {
  return (
    <div>Anime</div>
  )
}

export default Anime